import React from "react";
import { CiSearch } from "react-icons/ci";
import People from "../../../../helper/svg/People.svg";
import { FiEye } from "react-icons/fi";
import { MdOutlineEdit } from "react-icons/md";
import { RiDeleteBin6Line, RiDeleteBinLine } from "react-icons/ri";
import { IoMdEye } from "react-icons/io";
import { Link } from "react-router-dom";
import { useTranslation } from "../../../../hooks/useTranslation";
import { BiBed } from "react-icons/bi";
const AllRooms = ({ rooms, handleDeleteRoom, searchQuery, setSearchQuery, isLoading }) => {
  const { t } = useTranslation();

  // if (isLoading) {
  //   return <div className="flex justify-center py-12">
  //     <div className="w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full animate-spin" />
  //   </div>
  // }

  return (
    <>
      <div className="mt-[31px]">
        <div className="rounded-[10px] border border-[#D9D9D9] overflow-hidden mt-[28px] py-[20px] sm:px-[30px] px-[15px] bg-white">
          <div className="flex justify-between items-center py-[13px] flex-wrap  gap-[10px]">
            <h2 className="text-[22px] font-medium">{t("allRooms").title}</h2>
            <div className="relative w-full max-w-[301px]">
              <span className="absolute inset-y-0 left-3 flex items-center">
                <CiSearch size={24} className="text-[#4CAF50]" />
              </span>
              <input
                type="text"
                placeholder={t("allRooms").searchPlaceholder}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-4 py-2 rounded-full border border-[#DDDDDD] focus:outline-none focus:border-[#4CAF50]"
              />
            </div>
          </div>

{isLoading?<div className="flex justify-center py-12">
       <div className="w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full animate-spin" />
     </div>:<div className="overflow-x-auto md:mt-[30px] mt-[20px] grid">
            <table className="min-w-full  ">
              <thead className="bg-[#FFFAF2] ">
                <tr className="">
                  <th className="text-left text-sm font-medium text-[#000000] py-[12px] px-[16px] whitespace-nowrap">
                    <input
                      type="checkbox"
                      className="appearance-none bg-white border border-[#6E7491] w-[16px] h-[16px] rounded-full checked:bg-[#4CAF50] checked:border-[3px] checked:border-[#ffa808]"
                      id="checkbox1"
                    />
                  </th>
                  <th className="text-left text-sm font-medium text-[#000000] py-[12px] px-[16px] whitespace-nowrap">
                    {t("allRooms").tableHeaders.roomNo}
                  </th>
                  <th className="text-left text-sm font-medium text-[#000000] py-[12px] px-[16px] whitespace-nowrap">
                    {t("allRooms").tableHeaders.roomType}
                  </th>
                  <th className="text-left text-sm font-medium text-[#000000] py-[12px] px-[16px] whitespace-nowrap">
                    {t("allRooms").tableHeaders.roomFloor}
                  </th>

                  <th className="text-left text-sm font-medium text-[#000000] py-[12px] px-[16px] whitespace-nowrap">
                    {t("allRooms").tableHeaders.bedType}
                  </th>
                  <th className="text-left text-sm font-medium text-[#000000] py-[12px] px-[16px] whitespace-nowrap">
                    {t("allRooms").tableHeaders.capacity}
                  </th>
                  <th className="text-left text-sm font-medium text-[#000000] py-[12px] px-[16px] whitespace-nowrap">
                    {t("allRooms").tableHeaders.status}
                  </th>
                  <th className="text-left text-sm font-medium text-[#000000] py-[12px] px-[16px] whitespace-nowrap">
                    {t("allRooms").tableHeaders.description}
                  </th>
                  <th className="text-left text-sm font-medium text-[#000000] py-[12px] px-[16px] whitespace-nowrap">
                    {t("allRooms").tableHeaders.actions}
                  </th>
                </tr>
              </thead>
              <tbody>
                
                {rooms.length === 0 ? (
                  <tr>
                    <td colSpan="9">
                      <div className="flex flex-col items-center justify-center py-20 px-4 text-center">
                        <div className="w-14 h-14 rounded-full bg-[#E7F4ED] flex items-center justify-center mb-4">
                          <BiBed className="text-[#4CAF50] text-2xl" />
                        </div>
                        <p className="text-lg font-semibold text-[#111827]">
                          {t("allRooms").noRooms}
                        </p>
                        <p className="text-sm text-[#6B7280] mt-2 max-w-[360px]">
                          {t("allRooms").emptyRoomsHint ||
                            "Try adjusting filters or search with another keyword."}
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  rooms.map((room) => {
                    const description = room.description
                      ? room.description.split(" ").slice(0, 5).join(" ") +
                      "..."
                      : "";
                    return (
                      <tr key={room._id} className="border-t border-[#E4E4E4]">
                        <td className="py-[12px] px-[16px] text-[14px] font-normal text-black">
                          <input
                            type="checkbox"
                            className="appearance-none bg-white border border-[#6E7491] w-[16px] h-[16px] rounded-full checked:bg-[#4CAF50] checked:border-[3px] checked:border-[#ffa808]"
                          />
                        </td>
                        <td className="py-[12px] px-[16px] text-[14px] font-normal text-black whitespace-nowrap">
                          {room.roomNumber}
                        </td>
                        <td className="py-[12px] px-[16px] text-[14px] font-normal text-black whitespace-nowrap">
                          {room.roomType}
                        </td>
                        <td className="py-[12px] px-[16px] text-[14px] font-normal text-black whitespace-nowrap">
                          {room.roomFloor}
                        </td>
                        <td className="py-[12px] px-[16px]">{room.bedType}</td>
                        <td className="py-[12px] px-[16px] text--[17px] text-black">
                          <div className="flex gap-1 items-center">
                            <img
                              src={People}
                              alt="people"
                              className="w-[16px] h-[16px]"
                            />
                            {room.roomCapacity}
                          </div>
                        </td>
                        <td className="py-[12px] px-[16px]">
                          <div className="px-[18px] py-1 text-white bg-[#4CAF50] font-semibold rounded-full text-center">
                            {room.reservationStatus}
                          </div>
                        </td>
                        <td className="py-[12px] px-[16px]">{description}</td>
                        <td className="py-[12px] px-[16px] flex gap-[12px]">
                          <Link
                            to={{
                              pathname: "/addnewroom",
                            }}
                            state={{ isEditing: true, roomData: room }}
                            className="text-black font-normal w-[32px] h-[32px] flex items-center justify-center rounded-full bg-[#F2F2F2]"
                          >
                            <IoMdEye className="text-base text-black" />
                          </Link>
                          <button
                            onClick={() => handleDeleteRoom(room._id)}
                            className="text-black font-normal w-[32px] h-[32px] flex items-center justify-center rounded-full bg-[#F2F2F2]"
                          >
                            <RiDeleteBin6Line className="text-base text-black" />
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>}
          
        </div>
      </div>
    </>
  );
};

export default AllRooms;
